export const EIOT_EMULATE_VALUES = {
  WEATHER_DATA: {
    GPSLocation: '+32.843544:-080.016016:+0049.80',
    RelWindDir: 44,
    RelWindSpeed: 1.72,
    Temperature: 85.9,
    Dewpoint: 74.5,
    RelHumidity: 68,
    RainPresent: false,
    Pressure: 1020.5,
  },
  EMULATE_DEVICE: [
    {
      "SiteName": "Black Ink",
      "ProjectID": 21,
      "LocationName": "Black Ink Location",
      "Address1": "",
      "Address2": "",
      "City": "",
      "State": "",
      "PostalCode": "",
      "ID": 3331,
      "KioskName": "BIT-EMULATE-01",
      "UnitName": "BIT-EMULATE-01",
      "RefID": "da0b17a6-aaf4-48a0-9a14-9a99c273eb15",
      "SiteID": 9,
      "LocationID": 9,
      "Active": true,
      "IsOffline": 1
    },
    {
      "SiteName": "Black Ink",
      "ProjectID": 21,
      "LocationName": "Black Ink Location",
      "Address1": "",
      "Address2": "",
      "City": "",
      "State": "",
      "PostalCode": "",
      "ID": 3332,
      "KioskName": "BIT-EMULATE-02",
      "UnitName": "BIT-EMULATE-02",
      "RefID": "51c033f7-be85-4a42-bc90-9718ddd3c729",
      "SiteID": 9,
      "LocationID": 9,
      "Active": true,
      "IsOffline": 1
    },
    {
      "SiteName": "Black Ink",
      "ProjectID": 21,
      "LocationName": "Black Ink Location",
      "Address1": "",
      "Address2": "",
      "City": "",
      "State": "",
      "PostalCode": "",
      "ID": 3333,
      "KioskName": "BIT-EMULATE-03",
      "UnitName": "BIT-EMULATE-03",
      "RefID": "b3cd7def-9572-4b17-86f0-ac8e5242733d",
      "SiteID": 9,
      "LocationID": 9,
      "Active": true,
      "IsOffline": 1
    },
    {
      "SiteName": "Black Ink",
      "ProjectID": 21,
      "LocationName": "Black Ink Location",
      "Address1": "",
      "Address2": "",
      "City": "",
      "State": "",
      "PostalCode": "",
      "ID": 3334,
      "KioskName": "BIT-EMULATE-04",
      "UnitName": "BIT-EMULATE-04",
      "RefID": "cd4a2583-c752-426c-84ff-5903b726b15d",
      "SiteID": 9,
      "LocationID": 9,
      "Active": true,
      "IsOffline": 1
    },
    {
      "SiteName": "Black Ink",
      "ProjectID": 21,
      "LocationName": "Black Ink Location",
      "Address1": "",
      "Address2": "",
      "City": "",
      "State": "",
      "PostalCode": "",
      "ID": 3335,
      "KioskName": "BIT-EMULATE-05",
      "UnitName": "BIT-EMULATE-05",
      "RefID": "9005c6b7-4683-4996-baa1-7ec30313d8fb",
      "SiteID": 9,
      "LocationID": 9,
      "Active": true,
      "IsOffline": 1
    }  
  ]
}